import React, { useCallback, useState } from "react";
import { TextInput, PrimaryButton } from "../components/UIkit/";
// import { signUp } from "../reducks/users/operations";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import LanguageIcon from "@mui/icons-material/Language";
import { makeStyles } from "@material-ui/core";
import SelectWorker from "../components/User/SelectWorker";
const useStyle = makeStyles((theme) => ({
  userNumber: {
    display: "flex",
    alignItems: "center",
  },
  languageButton: {
    marginTop: "20px",
    width: "24px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#757575",
  },
}));
const SignUp = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [username, setUsername] = useState(""),
    [email, setEmail] = useState(""),
    [userid, setUserid] = useState(""),
    [role, setRole] = useState("customer"),
    [password, setPassword] = useState(""),
    [confirmPassword, setConfirmPassword] = useState(""),
    [usernumber, setUsernumber] = useState(""),
    [userdepnumber, setUserdepnumber] = useState(""),
    [userdepname, setUserdepname] = useState("");

  const [showSelectUser, setShowSelectUser] = useState(false);
  const handleLanguageButtonClick = () => {
    setShowSelectUser(true);
  };
  //メモ化
  const inputUsername = useCallback(
    (event) => {
      setUsername(event.target.value);
    },
    [setUsername]
  );
  const inputEmail = useCallback(
    (e) => {
      setEmail(e.target.value);
    },
    [setEmail]
  );
  const inputPassword = useCallback(
    (e) => {
      setPassword(e.target.value);
    },
    [setPassword]
  );

  const inputConfirmPassword = useCallback(
    (e) => {
      setConfirmPassword(e.target.value);
    },
    [setConfirmPassword]
  );

  return (
    <div className="c-section-container">
      <h2 className="u-text__headline u-text-center">アカウント登録</h2>
      <div className="module-spacer--medium" />
      <div className={classes.userNumber}>
        <TextInput
          fullWidth={true}
          label={"ユーザー情報"}
          multiline={false}
          required={true}
          minRows={1}
          value={username + " " + userdepname}
          type={"text"}
          disabled={true}
          onChange={inputUsername}
        />
        <button
          className={classes.languageButton}
          onClick={handleLanguageButtonClick}
        >
          <LanguageIcon />
        </button>
      </div>
      <TextInput
        fullWidth={true}
        label={"メールアドレス"}
        multiline={false}
        required={true}
        minRows={1}
        value={email}
        type={"email"}
        onChange={inputEmail}
      />
      <TextInput
        fullWidth={true}
        label={"パスワード（半角英数字で6文字以上）"}
        multiline={false}
        required={true}
        minRows={1}
        value={password}
        type={"password"}
        onChange={inputPassword}
      />
      <TextInput
        fullWidth={true}
        label={"パスワードの再確認"}
        multiline={false}
        required={true}
        minRows={1}
        value={confirmPassword}
        type={"password"}
        onChange={inputConfirmPassword}
      />
      <div className="module-spacer--medium" />
      <div className="center">
        {/* <PrimaryButton
                    label={"アカウントを登録する"}
                    onClick={() => dispatch(signUp(username, email, password, confirmPassword, usernumber, userdepnumber, userdepname))}
                /> */}
        <div className="module-spacer--small" />
        <p className="u-text-small" onClick={() => dispatch(push("/signin"))}>
          アカウントをお持ちの方はこちら
        </p>
      </div>
      {showSelectUser && (
        <SelectWorker
          username={username}
          setUsername={setUsername}
          usernumber={usernumber}
          setUsernumber={setUsernumber}
          userdepnumber={userdepnumber}
          setUserdepnumber={setUserdepnumber}
          userdepname={userdepname}
          setUserdepname={setUserdepname}
          setShowSelectUser={setShowSelectUser}
          email={email}
          setEmail={setEmail}
          role={role}
          setRole={setRole}
        />
      )}
    </div>
  );
};

export default SignUp;
